/// <amd-module name="Artifacts/Maven/redux/Module" />
import { rootSaga } from "Artifacts/Maven/redux/Sagas";
import { PackageModule } from "Artifacts/Package/redux";
import { ISagaModule } from "redux-dynamic-modules-saga";

const _MavenModule: ISagaModule<Record<string, never>> = {
  id: "maven-protocol-module",
  reducerMap: {},
  sagas: [rootSaga],
};

export const MavenModule = [PackageModule, _MavenModule];
